import React from 'react'
import RegulationDefault from './RegulationDefault'
import RegulationIupp from './RegulationIupp'
import yn from 'yn'

const RegulationPage = () => {
  return yn(process.env.REACT_APP_HAS_REGULATION_CUSTOM) ? <RegulationIupp /> : <RegulationDefault />
}

export default RegulationPage



// WEBPACK FOOTER //
// ./src/features/Regulation/RegulationPage.js